import React, { Component } from "react";
import { Button, Modal, Nav, Navbar } from "react-bootstrap";

class Uvod extends Component {
  state = {
    lazne: -1,
    odkazy: [
      {
        name: "Lázeňský dům Aurora",
        link: "#/la",
        odkazy: [
          /*{
            nazev: "Soutěž s Lázeňskou pohodou",
            link:
              "https://forms.office.com/Pages/ResponsePage.aspx?id=WDPHJZrpkEq8iewp2JzOnONqCaoGyd5EgxSieyhAx2NUMEpXTFNaOUhUQ0tZRlZXOEI4QzNZVjZaVCQlQCN0PWcu",
          },*/
          {
            nazev: "Dotazník spokojenosti",
            link: "https://forms.office.com/Pages/ResponsePage.aspx?id=WDPHJZrpkEq8iewp2JzOnONqCaoGyd5EgxSieyhAx2NUNlJGSDRYRExBV0ozOENHRk9ETVdTOFZFQyQlQCN0PWcu",
          },
          {
            nazev: "Připomínky a sdělení",
            link: "https://forms.office.com/Pages/ResponsePage.aspx?id=WDPHJZrpkEq8iewp2JzOnONqCaoGyd5EgxSieyhAx2NUNVJJWjJKNlIxMk44S1VVQ0hPWllZWVIyQiQlQCN0PWcu",
          },
        ],
      },
      {
        name: "Lázeňský dům Berta",
        link: "#/bl",
        odkazy: [
          /*{
            nazev: "Soutěž s Lázeňskou pohodou",
            link:
              "https://forms.office.com/Pages/ResponsePage.aspx?id=WDPHJZrpkEq8iewp2JzOnONqCaoGyd5EgxSieyhAx2NUMEpXTFNaOUhUQ0tZRlZXOEI4QzNZVjZaVCQlQCN0PWcu",
          },*/
          {
            nazev: "Dotazník spokojenosti",
            link: "https://forms.office.com/Pages/ResponsePage.aspx?id=WDPHJZrpkEq8iewp2JzOnONqCaoGyd5EgxSieyhAx2NUNlJGSDRYRExBV0ozOENHRk9ETVdTOFZFQyQlQCN0PWcu",
          },
          {
            nazev: "Připomínky a sdělení",
            link: "https://forms.office.com/Pages/ResponsePage.aspx?id=WDPHJZrpkEq8iewp2JzOnONqCaoGyd5EgxSieyhAx2NUQ1lWVVNVTzMxT1hTQ1JZM1gyN0JZMDg1RiQlQCN0PWcu",
          },
        ],
      },
    ],
  };

  componentDidMount = () => {
    this.setLazne();
  };

  componentDidUpdate = () => {
    this.setLazne();
  };

  setLazne = () => {
    const { lazne } = this.props.match.params;
    switch (lazne) {
      case "la":
        if (this.state.lazne !== 0) {
          this.setState({ lazne: 0 });
        }
        break;
      case "bl":
        if (this.state.lazne !== 1) {
          this.setState({ lazne: 1 });
        }
        break;
    }
  };

  timer = false;
  timer2 = false;

  rozcestnik = () => {
    const { lazne, odkazy } = this.state;
    return (
      <div className="row">
        <div className="col-12 text-center mb-5" style={{ marginTop: "200px" }}>
          <img
            src="https://www.laznetrebon.cz/img/logo/msl-logo-white.svg?1.1"
            className="logo"
          />
        </div>
        {odkazy[lazne].odkazy.map((o, index) => (
          <div className="col-6 text-center" key={index}>
            <button
              className="btn-rozcestnik"
              onClick={() => this.setLink(o.link)}
            >
              {o.nazev}
            </button>
          </div>
        ))}
      </div>
    );
  };

  setLink = (link) => {
    this.setState({ link: link + "&rnd=" + Math.random() });
    if (!link) {
      if (this.timer) {
        clearTimeout(this.timer);
      }
    } else {
      this.timer = setTimeout(() => this.doAlert(), 5 * 60 * 1000);
    }
  };

  doAlert = () => {
    this.setState({ showAlert: true });
    this.timer2 = setTimeout(
      () => this.setState({ showAlert: false, link: false }),
      5000
    );
  };

  prolong = () => {
    const { link } = this.state;
    if (this.timer2) {
      clearTimeout(this.timer2);
    }
    this.setLink(link);
    this.setState({ showAlert: false });
  };

  link() {
    const { link, lazne, odkazy, showAlert } = this.state;
    return (
      <React.Fragment>
        <Modal show={showAlert}>
          <Modal.Header style={{ color: "black" }}>Dotaz</Modal.Header>
          <Modal.Body style={{ color: "black" }}>
            Stále ještě vyplňujete dotazník? Pokud ano, klikněte na pokračovat,
            jinak bude dotazník uzavřen.
          </Modal.Body>
          <Modal.Footer>
            <Button variant="success" onClick={this.prolong}>
              Pokračovat
            </Button>
          </Modal.Footer>
        </Modal>
        <Navbar id="navbar">
          <Navbar.Brand>
            <img
              src="https://www.laznetrebon.cz/img/logo/msl-logo-white.svg?1.1"
              style={{ width: "150px" }}
            />
          </Navbar.Brand>
          <Navbar.Collapse>
            {odkazy[lazne].odkazy.map((o, index) => (
              <Nav.Link key={index} onClick={() => this.setLink(o.link)}>
                {o.nazev}
              </Nav.Link>
            ))}
          </Navbar.Collapse>
        </Navbar>
        <iframe
          src={link}
          style={{
            width: "100%",
            border: "none",
            height: window.innerHeight - 59 + "px",
          }}
        />
      </React.Fragment>
    );
  }

  render() {
    console.log("PROPS", this.props);
    const { lazne, odkazy, link } = this.state;
    return (
      <div>
        {lazne >= 0 ? (
          link ? (
            this.link()
          ) : (
            this.rozcestnik()
          )
        ) : (
          <div className="row">
            <div className="col-12 text-center mt-5 mb-5">
              <img
                src="https://www.laznetrebon.cz/img/logo/msl-logo-white.svg?1.1"
                className="logo"
              />
            </div>
            <div
              className="col-12 text-center"
              style={{ paddingTop: "30px", paddingBottom: "30px" }}
            >
              <h3>Zvolte lázně, pro které chcete zobrazit rozcestník</h3>
            </div>
            {odkazy.map((o, index) => (
              <div className="col-6 text-center" key={index}>
                <a className="btn btn-primary" href={o.link}>
                  {o.name}
                </a>
              </div>
            ))}
          </div>
        )}
      </div>
    );
  }
}

export default Uvod;
